import { useAuditApi } from "./common/auditApi";

export function useShapeAuditApi() {
  return useAuditApi({
    url: 'shape',
    translateTitle: (t) => t.audit.actions.fetchShape.title,
    translateError: (t) => t.audit.actions.fetchShape.error,
  });
}
